import Vue from 'vue';
import chartOfAccountsTransformer from './../../transformers/chartOfAccounts';
import all from './all';

const success = (data, resolve) => {
  all();
  resolve();
};

const failed = (errors, reject) => {
  reject(chartOfAccountsTransformer.fetch(errors));
};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/chart_of_accounts/create_coa')
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/chartOfAccounts/createCoa.js